import { configureStore } from '@reduxjs/toolkit';
import repeatSlice from './RepeatSlice';


export default configureStore({
  reducer: {
    repetition: repeatSlice
  
  }
})